/**
 * Основной контроллер для управления логикой хлебных крошек.
 * Класс может быть отнаследовани и расширен в каждом из вариантов.
 */
class cBreadcrumbsController {
	constructor($bc) {
		if (!$bc.length) {
			throw new Error('Не передан объект хлебных крошек');
		}

		this.bc = $bc; //объект хлебных крошек
		this.shortClass = 'is-short'; //класс для состояния полного скрытия элемента хлебных крошек
		this.partiallyShortClass = 'is-partially-short'; //класс для состояния частичного скрытия элемента хлебных крошек
	}

	/**
	 * Проверяет нужно ли подключать функционал коротких хлебных крошек
	 * @returns {boolean}
	 */
	isNeedDoingCheck($bc = this.bc) {
		return (Boolean($bc.find('.js-item').length));
	}

	/**
	 * Имеются ли полностью или частично скрытые элементы в хлебных крошках
	 * @returns {boolean}
	 */
	hasHiddenItems($bc = this.bc) {
		return (Boolean($bc.find(`.js-item.${this.shortClass}`).length) || Boolean($bc.find(`.js-item.${this.partiallyShortClass}`).length));
	}

	/**
	 * Возвращает общую ширину элементов хлебных крошек
	 * @returns {number}
	 */
	getBreadcrumbsWidth($bc = this.bc) {
		let width = 0;
		$.each($bc.find('.js-item'), function () {
			width += $(this).outerWidth(true);
		});
		return width;
	}

	/**
	 * Метод проверяет, влезают ли хлебные крошки в родителя
	 * @returns {boolean}
	 */
	isFit($bc = this.bc) {
		let parentWidth = $bc.parent().width();
		let breadcrumbsWidth = this.getBreadcrumbsWidth($bc);
		let itemsCount = $bc.find('.js-item').length;
		let result = true;
		if (breadcrumbsWidth > parentWidth) {
			result = false;
		}
		return result;
	}

	/**
	 * Получить самый левый из видимых элементов,
	 * которые можно переключать
	 */
	getMostLeftShownItem($bc = this.bc) {
		let $items = $bc.find(`.js-item-can-switch:not(.${this.shortClass})`);
		return ($items.length) ? $items.first() : false;
	}

	/**
	 * Получить самый правый из скрытых элементов,
	 * которые можно переключить
	 */
	getMostRightHiddenItem($bc = this.bc) {
		let $items = $bc.find(`.js-item-can-switch.${this.shortClass}, .js-item-can-switch.${this.partiallyShortClass}`);
		return ($items.length) ? $items.last() : false;
	}

	/**
	 * Получить самый длинный из видимых,
	 * которые можно переключить
	 */
	getMostLongShownItem($bc = this.bc) {
		let $items = $bc.find(`.js-item-can-switch:not(.${this.shortClass}):not(.${this.partiallyShortClass})`);
		if ($items.length) {
			let $resultItem = $($items.first());
			$items.each(function () {
				let currentInnerWidth = $(this).find('.js-inner').width();
				let resultInnerWidth = $resultItem.find('.js-inner').width();
				if (currentInnerWidth > resultInnerWidth) {
					$resultItem = $(this);
				}
			});
			return $resultItem;
		} else {
			return $items;
		}
	}

	/**
	 * Получить самый короткий из скрытых,
	 * которые можно переключить
	 */
	getMostShortHiddenItem($bc = this.bc) {
		let $items = $bc.find(`.js-item-can-switch.${this.shortClass}, .js-item-can-switch.${this.partiallyShortClass}`);
		if ($items.length) {
			let $resultItem = $($items.first());
			$items.each(function () {
				let currentInnerWidth = $(this).find('.js-inner').width();
				let resultInnerWidth = $resultItem.find('.js-inner').width();
				if (currentInnerWidth < resultInnerWidth) {
					$resultItem = $(this);
				}
			});
			return $resultItem;
		} else {
			return $items;
		}
	}

	/**
	 * Возвращает полную ширину элемента
	 * Полезно, когда у элемента задана ширина через стили, а нужно получить полную актуальную ширину
	 * @param $item
	 */
	getFullWidthFromItem($item) {
		//загружаем элемент в новый контейнре, что бы получить у него актуальные размеры
		let $graphicDOMWrapper = $('<div/>')
			.css({
				position: 'fixed',
				left: '-9999px',
				width: '1024px'
			});

		let $cloneItem = $item
			.clone()
			.width('auto')
			.css('display', 'inline-block');

		$('body').append($graphicDOMWrapper.append($cloneItem));

		let itemWidth = $cloneItem.width();
		$graphicDOMWrapper.remove();

		return itemWidth;
	}

	/**
	 * Удалает подсказку у элемента
	 * @param $item
	 */
	removeTooltipFromItem($item) {
		if ($item.hasClass('tooltip')) {
			let $itemContext = $item.find('.tooltip__text');
			$item.removeClass('tooltip');

			if ($itemContext.length) {
				$item.attr('title', $itemContext.text());
				$item.empty();
			}
		}
	}

	/**
	 * Добавляет подсказку к элементу
	 * @param $item
	 */
	addTooltipToItem($item) {
		let text = $item.attr('title');

		if (!$item.hasClass('tooltip')) {
			$item
				.attr('title', '')
				.addClass('tooltip')
				.append(`<span class="tooltip__text tooltip__text--bottom">${text}</span>`);
		}
	}
}

module.exports = cBreadcrumbsController;



// WEBPACK FOOTER //
// ./temp/components/breadcrumbs/index.js